module.exports = __webpack_public_path__ + "media/images/ui__infoBox-6d86c51a797cd3accd403a264059d148.png";